import logohorizontal from "../../../assets/logohorizontal.png";

function TermoAceite() {
  return (
    <>
      <div
        style={{
          margin: "auto",
          width: "90%",
          color: "#000000",
        }}
      >
        <img
          className="mainLogoDarkFooter"
          src={logohorizontal}
          alt="mainLogo"
          style={{ width: "65px", height: "auto" }}
        />
        <h2 style={{ fontSize: "20px", fontWeight: "bold" }}>
          Política Privacidade
        </h2>
        <div
          style={{
            height: "250px",
            zIndex: 0,
            overflowY: "scroll",
            marginTop: 15,
          }}
        >
          <br />
          A sua privacidade é importante para nós. É política do Fynd respeitar
          a sua privacidade em relação a qualquer informação sua que possamos
          coletar no site/aplicativo Fynd, e outros sites que possuímos e
          operamos.
          <br />
          <br />
          Solicitamos informações pessoais apenas quando realmente precisamos
          delas para lhe fornecer um serviço. Fazemo-lo por meios justos e
          legais, com o seu conhecimento e consentimento. Também informamos por
          que estamos coletando e como será usado.
          <br />
          <br />
          Apenas retemos as informações coletadas pelo tempo necessário para
          fornecer o serviço solicitado. Quando armazenamos dados, protegemos
          dentro de meios comercialmente aceitáveis ​​para evitar perdas e
          roubos, bem como acesso, divulgação, cópia, uso ou modificação não
          autorizados.
          <br />
          <br />
          Não compartilhamos informações de identificação pessoal publicamente
          ou com terceiros, exceto quando exigido por lei.
          <br />
          <br />
          O nosso site/aplicativo pode ter links para sites externos que não são
          operados por nós. Esteja ciente de que não temos controle sobre o
          conteúdo e práticas desses sites e não podemos aceitar
          responsabilidade por suas respectivas políticas de privacidade.
          <br />
          <br />
          Você é livre para recusar a nossa solicitação de informações pessoais,
          entendendo que talvez não possamos fornecer alguns dos serviços
          desejados.
          <br />
          <br />
          O uso continuado de nosso site/aplicativo será considerado como
          aceitação de nossas práticas em torno de privacidade e informações
          pessoais. Se você tiver alguma dúvida sobre como lidamos com dados do
          usuário e informações pessoais, entre em contacto connosco.
          <br />
          <br />
          Compromisso do Usuário O usuário se compromete a fazer uso adequado
          dos conteúdos e da informação que o Fynd oferece no site/aplicativo e
          com caráter enunciativo, mas não limitativo:
          <br />
          <br />
          <p>
            A) Não se envolver em atividades que sejam ilegais ou contrárias à
            boa fé a à ordem pública;
          </p>
          <p>
            B) Não difundir propaganda ou conteúdo de natureza racista,
            xenofóbica, generador de avisos de privacidad ou azar, qualquer tipo
            de pornografia ilegal, de apologia ao terrorismo ou contra os
            direitos humanos;
          </p>
          <p>
            C) Não causar danos aos sistemas físicos (hardwares) e lógicos
            (softwares) do Fynd, de seus fornecedores ou terceiros, para
            introduzir ou disseminar vírus informáticos ou quaisquer outros
            sistemas de hardware ou software que sejam capazes de causar danos
            anteriormente mencionados.
          </p>
          <br />
          <br />
          Mais informações Esperemos que esteja esclarecido e, como mencionado
          anteriormente, se houver algo que você não tem certeza se precisa ou
          não, geralmente é mais seguro deixar os cookies ativados, caso
          interaja com um dos recursos que você usa em nosso site. <br /> <br />
          Esta política é efetiva a partir de 21 outubro 2022 12:33
          <br />
          <br />
        </div>
      </div>
    </>
  );
}

export default TermoAceite;
